module.exports = __webpack_public_path__ + "img/prestashop.840558f0.png";